import connect from '../../../utils/socket';

export default {
  ['SOCKET_CONNECT']: ({ commit }) => {
    const connection = connect();
    commit('SET_SOCKET_CONNECTION', { ...connection} );
  }
}
